import { DivisionService } from "./../../../services/catalogs/DivisionService";
import React from "react";
import { DivisionDetail } from "../../../components/Pages/Catalogs/Division/DivisionDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateDivisionDto } from "../../../dtos/catalogs/divison/CreateDivisionDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupDivision } from "../../../components/Shared/NewForms/NFLookupDivision";
import DivisionList from "../../../components/Pages/Catalogs/Division/DivisionList";

export const Division: IAppEntity = {
  entityType: "catalog",
  title: "Division",
  pluralTitle: "Divisions",
  apiUrl: "Divisions",
  apiEnum: ReferenceTypes.CatalogDivision,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(DivisionDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DivisionList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDivision, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new DivisionService("Divisions"),
  getEmptyModel: () => {
    const model: CreateDivisionDto = {
      name: "",
    };
    return model;
  },
};
